import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import CollectionCard from 'components/organisms/Cards/CollectionCard/CollectionCard';
import {useCollectionList} from 'services/collection/collection.hooks';
import Section from 'components/organisms/Sections/Section/Section';
import StyledRecentCollectionsDashboardCard
  from 'components/organisms/Cards/RecentCollectionsDashboardCard/RecentCollectionsDashboardCard.styles';
import utils from 'helpers/utils';
import {P} from 'components/atoms/Text/Typography/Typography';
import Box from 'components/atoms/Layout/Box/Box';

const RecentCollectionsDashboardCard = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps({
    title: 'You\'ve recently worked on',
    density: 'densest',
    variant: 'small',
    elevation: 0,
    ...props
  }, 'RecentCollectionsDashboardCard', {
    children: ['section']
  });

  const list = useCollectionList({
    sort: [{id: 'last_updated_at', desc: true}],
    pageSize: 10
  });
  const isLoading = list?.status?.isLoading || !utils.isDefined(list?.data)

  return <StyledRecentCollectionsDashboardCard ref={ref} {...innerProps}>
    {(list?.data?.length > 0 || isLoading) ? <Section className="RecentCollectionsDashboardCard-section"
             Loader={<CollectionCard isLoading={true}/>}
             loaderCount={8}
             isLoading={isLoading}
             gap={16}>
      {list?.data?.map((collection, index) => {
        return <CollectionCard key={index} collection={collection}/>;
      })}
    </Section> : null}
    {(list?.data?.length === 0 && !isLoading) ? <Box className="DashboardCard-empty">
      <P>No recent collection(s) found</P>
    </Box> : null}
  </StyledRecentCollectionsDashboardCard>
});

RecentCollectionsDashboardCard.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
};

export default RecentCollectionsDashboardCard;
